<svg [ngClass]="class" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_5906_19856)">
    <path d="M9.66357 18.6637L14.8161 13.5L9.66357 8.33625L11.2498 6.75L17.9998 13.5L11.2498 20.25L9.66357 18.6637Z" fill="#372121"/>
  </g>
  <defs>
    <clipPath id="clip0_5906_19856">
      <rect width="27" height="27" fill="white"/>
    </clipPath>
  </defs>
</svg>
